module.exports = __webpack_public_path__ + "static/img/delivery-owl.a64852b2.svg";